<div class="e11-w-full lg:e11-hidden">
  <div class="e11-flex e11-mb-4">
    <div class="e11-flex e11-items-center">
      <app-nav-left></app-nav-left>
    </div>
  </div>
</div>
